export default [
    {
        path: '/rooms',
        name: 'Room_List',
        component: () => import('@/views/meeting/room/list.vue'),
        meta: {
            authRequired: true,
            permission: 'rooms.index'
        }
    },
    {
        path: '/rooms/create',
        name: 'Room_Create',
        component: () => import('@/views/meeting/room/create.vue'),
        meta: {
            authRequired: true,
            permission: 'rooms.store'
        }
    },
    {
        path: '/rooms/:id/edit',
        name: 'Room_Edit',
        component: () => import('@/views/meeting/room/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'rooms.show',
            navActiveLink:'Room_List'
        }
    },
    {
        path: '/room-reservations',
        name: 'RoomReservation_List',
        component: () => import('@/views/meeting/room-reservation/list.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.index'
        }
    },
    {
        path: '/room-reservations/create',
        name: 'RoomReservation_Create',
        component: () => import('@/views/meeting/room-reservation/create.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.store'
        }
    },
    {
        path: '/room-reservations/:id/edit',
        name: 'RoomReservation_Edit',
        component: () => import('@/views/meeting/room-reservation/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.update',
            navActiveLink:'RoomReservation_List'
        }
    },
    {
        path: '/room-reservations/list',
        name: 'RoomReservation_AdminList',
        component: () => import('@/views/meeting/admin/list.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.admin.update'
        }
    },
    {
        path: '/room-reservations/:id/admin-edit',
        name: 'RoomReservation_AdminEdit',
        component: () => import('@/views/meeting/admin/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.admin.update',
            navActiveLink:'RoomReservation_AdminList'
        }
    },
    {
        path: '/room-reservations/time-sheet',
        name: 'RoomReservation_TimeSheet',
        component: () => import('@/views/meeting/admin/timesheet.vue'),
        meta: {
            authRequired: true,
            permission: 'room-reservations.admin.update'
        }
    },
]
